import SearchInputIcon from './search.png';

const Images = {
  SearchInputIcon,
};

export default Images;
